import { twMerge } from "tailwind-merge";
import { useSubMenu } from "../SubMenuContext";

const ThirdMenu = ({ children }: { children: React.ReactNode }) => {
    const { isContentOpen, sideWidth } = useSubMenu();

    return (
        <>
            <div className={twMerge(`flex flex-row max-[460px]:relative max-[460px]:left-[0px] max-[460px]:z-[1] bg-white rounded-tr-xl rounded-tl-xl ml-2 transition-all duration-200`, `${isContentOpen ? 'mr-2' : ''}`)} style={{width: isContentOpen ? sideWidth : ''}}>
                {children}
            </div>
        </>
    )
};

export default ThirdMenu;